import * as types from "./types.js"
import * as api from "./api.js"


function postFileRequest() {
    return {
        type: types.POST_FILE_REQUEST
    }
}

/*function postFileReceived(stats) {
    return {
        type: types.POST_FILE_RECEIVED,
        payload: stats
    }
}*/

function postFileError(e) {
    return {
        type: types.POST_FILE_ERROR,
        payload: e,
        error: true
    }
}

export function postFile(formData) {
    return dispatch => {
        dispatch(postFileRequest())
        return api.postFile(formData)
        .then(res => {
            if (res.status !== 200) {
                return res.text()
                .then(text => {
                    dispatch(postFileError(text ? text : res.statusText))
                })
            } else {
                return res.json()
                .then(stats => {
                    dispatch(getFiles(formData.get("personid")))
                })
            }
        })
    }
}

function getFilesRequest() {
    return {
        type: types.GET_FILES_REQUEST
    }
}

function getFilesReceived(visas) {
    return {
        type: types.GET_FILES_RECEIVED,
        payload: visas
    }
}

function getFilesError(e) {
    return {
        type: types.GET_FILES_ERROR,
        payload: e,
        error: true
    }
}

export function getFiles(personid) {
    return dispatch => {
        dispatch(getFilesRequest())
        return api.getFiles(personid)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getFilesError(res.statusText))
            } else {
                return res.json()
                .then(visas => {
                    dispatch(getFilesReceived(visas))
                })
            }
        })
    }
}

function deleteFileRequest() {
    return {
        type: types.DELETE_FILE_REQUEST
    }
}

function deleteFileReceived(visa) {
    return {
        type: types.DELETE_FILE_RECEIVED,
        payload: visa
    }
}

function deleteFileError(e) {
    return {
        type: types.DELETE_FILE_ERROR,
        payload: e,
        error: true
    }
}

export function deleteFile(id) {
    return dispatch => {
        dispatch(deleteFileRequest())
        return api.deleteFile(id)
        .then(res => {
            if (res.status !== 200) {
                dispatch(deleteFileError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(deleteFileReceived({ id }))
                })
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/files/actions.js
 **/